// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Section CSS Module
 * Styles for MultiViewCampaignSection component
 */
/* Loading State */
.TH0nuphU_13Jbdl1Ztuw {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/MultiViewCampaignSection/MultiViewCampaignSection.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf","sourcesContent":["/**\n * Campaign Section CSS Module\n * Styles for MultiViewCampaignSection component\n */\n/* Loading State */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `TH0nuphU_13Jbdl1Ztuw`
};
export default ___CSS_LOADER_EXPORT___;
